// Clé de l'item de menu renvoyé par l'API (`useMenuItems`) sous `mon_cse`.
// Doit correspondre exactement à la clé backend pour que l'entrée de menu et le
// drawer de navigation s'affichent (route `/petites-annonces`, feature
// `service_classifieds`).
export const CLASSIFIED_ADS_MENU_KEY = "classifieds";

export const CLASSIFIED_ADS_PATH = "/petites-annonces";
// Persistence key that opens the classifieds navigation drawer (see menuBehaviors.ts).
// Distinct from CLASSIFIED_ADS_MENU_KEY, which is the API menu-item key.
export const CLASSIFIED_ADS_DRAWER_KEY = "classified-ads";
// Where a reporter lands after reporting an ad: the listing with the classifieds drawer open.
export const CLASSIFIED_ADS_DRAWER_PATH = `${CLASSIFIED_ADS_PATH}?drawer=${CLASSIFIED_ADS_DRAWER_KEY}`;
export const MY_CLASSIFIED_ADS_PATH = `${CLASSIFIED_ADS_PATH}/mes-annonces`;
export const MY_CLASSIFIED_ADS_MESSAGES_PATH = `${CLASSIFIED_ADS_PATH}/mes-conversations`;
// Conversations page with the classifieds drawer open (target of the unread bell).
export const MY_CLASSIFIED_ADS_MESSAGES_DRAWER_PATH = `${MY_CLASSIFIED_ADS_MESSAGES_PATH}?drawer=${CLASSIFIED_ADS_DRAWER_KEY}`;
export const MY_CLASSIFIED_AD_MESSAGE_PATH = `${MY_CLASSIFIED_ADS_MESSAGES_PATH}/:roomId`;
export const NEW_CLASSIFIED_AD_PATH = `${MY_CLASSIFIED_ADS_PATH}/nouvelle`;
export const EDIT_CLASSIFIED_AD_PATH = `${MY_CLASSIFIED_ADS_PATH}/:id/modifier`;
export const CLASSIFIED_AD_DETAIL_PATH = `${CLASSIFIED_ADS_PATH}/:id`;

export const buildClassifiedAdDetailPath = (id: string): string => `${CLASSIFIED_ADS_PATH}/${id}`;
export const buildClassifiedAdMessagePath = (roomId: string): string => `${MY_CLASSIFIED_ADS_MESSAGES_PATH}/${roomId}`;
export const buildEditClassifiedAdPath = (id: string): string => `${MY_CLASSIFIED_ADS_PATH}/${id}/modifier`;
